import { Stack } from '@jarvis/web-stratus-client'

/**
 * Returns the base URL for the PSW API stack environment based on the provided stack type.
 *
 * @param {Stack} stack - The stack environment type (dev, stage and prod).
 * @returns {string} The corresponding base URL for the specified stack environment.
 */
const getPswApiStack = (stack) => {
  let url = ''
  switch (stack) {
    case Stack.stage:
      url = 'https://psw-api-olex.stg.oc.hp.com'
      break
    case Stack.prod:
      url = 'https://psw-api-olex.oc.hp.com'
      break
    default:
      url = 'https://psw-api-olex.itg.oc.hp.com'
  }
  return url
}

export default getPswApiStack
